<template>
  <div class="concour-detail">
    <div class="inner">
      <p class="to-list-link"><router-link class="alp" to="/concour/">コンクール情報一覧ページ</router-link></p>
      <article v-if="ConcourDetail&&ConcourDetail.post">
        <div class="event-img">
          <img :src="ConcourDetail.post.img">
        </div>
        <div>
          <div class="tab-btn">
            <ul>
              <li class="btn info" :class="resultShow('info',ConcourDetail.post.contents_result)"><span>コンクール情報</span></li>
              <li class="btn result" :class="resultShow('btn-result',ConcourDetail.post.contents_result)"><span>結果発表</span><span class="date">（{{ ConcourDetail.post.result }}）</span></li>
            </ul>
          </div>
          <div class="tab-contents info" :class="resultShow('info',ConcourDetail.post.contents_result)">
            <ul>
              <li v-for="(list, i) in ConcourDetail.post.contents" :key="ConcourDetail.post.ID + '_co' + i">
                <div class="desc">
                  <h3 v-html="list.key"></h3>
                  <div>
                    <template v-for="(cont, j) in list.content">
                      <div v-if="cont.text" :key="ConcourDetail.post.ID + '_co' + i + '_' + j" v-html="cont.text"></div>
                      <div v-else-if="cont.btn_url" :key="ConcourDetail.post.ID + '_co' + i + '_' + j"><a :href="cont.btn_url" class="rounded-btn alp" target="_blank"><span>応募ページへのリンク</span></a></div>
                      <div v-else-if="cont.btn_pdf" :key="ConcourDetail.post.ID + '_co' + i + '_' + j"><a :href="cont.btn_pdf.url" class="download-btn alp" target="_blank"><span>応募用紙をダウンロードする</span></a></div>
                    </template>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="tab-contents result" :class="resultShow('result',ConcourDetail.post.contents_result)">
            <ul>
              <li v-for="(list, i) in ConcourDetail.post.contents_result" :key="ConcourDetail.post.ID + '_re' + i">
                <div class="desc">
                  <h3>{{ list.key }}</h3>
                  <div>
                    <template v-for="(cont, j) in list.content">
                      <div v-if="cont.text" :key="ConcourDetail.post.ID + '_re' + i + '_' + j" v-html="cont.text"></div>
                      <div v-else-if="cont.btn_url" :key="ConcourDetail.post.ID + '_re' + i + '_' + j"><a :href="cont.btn_url" class="rounded-btn alp" target="_blank"><span>結果発表</span></a></div>
                      <div v-else-if="cont.btn_pdf" :key="ConcourDetail.post.ID + '_re' + i + '_' + j"><a :href="cont.btn_pdf.url" class="download-btn alp" target="_blank"><span>応募用紙をダウンロードする</span></a></div>
                    </template>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </article>
      <SearchCommonDetail v-if="ConcourDetail && ConcourDetail.post" :currentId="ConcourDetail.post.ID" type="concour" />
      <div class="to-list-btn"><a class="alp" href="/concour/"><span>コンクール情報一覧ページを見る</span></a></div>
      <p class="pagetop"><a class="alp" href="#">ページトップへ</a></p>
    </div>
    <div class="bottom-nav">
      <ul>
        <li class="teaching alp"><a href="/teaching/"><span>教材</span></a></li>
        <li class="event alp"><a href="/event/"><span>イベント</span></a></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;

$white-border: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff, -2px 0 1px #fff,
  -2px -2px 1px #fff, 2px -2px 1px #fff, -2px 2px 1px #fff, 2px 2px 1px #fff;

.concour-detail {
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
    .to-list-link {
      padding: 30px 0;
      text-align: right;
      line-height: 1;
      a {
        -webkit-transform: perspective(1);
        font-size: 14px;
        color: $concour;
        font-weight: 500;
        text-shadow: $white-border;
        position: relative;
        padding-left: 2em;
        letter-spacing: 0.1em;
        line-height: 1;
        background: url(../assets/img/common/arrow_bg_pc.png) no-repeat center
          left;
      }
      a:before {
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border: 8px dashed transparent;
        border-right: 12px solid $concour;
        position: absolute;
        top: calc(50% - 8px);
        left: -6px;
      }
    }
    article {
      padding: 40px 40px 5px;
      background: #fff;
      .event-img img {
        width: 100%;
      }
      .tab-btn {
        margin: 30px 0 35px;
        border-bottom: 4px solid $concour;
        ul {
          @include flex();
          align-items: flex-end;
          li {
            -webkit-transform: perspective(1);
            width: 48.9%;
            font-size: 20px;
            text-align: center;
            font-weight: bold;
            color: $concour;
            border: 2px solid $concour;
            border-bottom: none;
            cursor: pointer;
            span:nth-of-type(1) {
              display: inline-block;
              padding: 13px 0;
              background-repeat: no-repeat;
              background-position: center left;
            }
            .date {
              font-size: 16px;
            }
            &:nth-of-type(1) span {
              padding-left: 33px;
              background-image: url(../assets/img/common/ico_pencil.png);
            }
            &:nth-of-type(2) span:nth-of-type(1) {
              padding-left: 37px;
              background-image: url(../assets/img/common/ico_cup.png);
            }
            &:nth-of-type(2) {
              .date {
                display: none;
              }
            }
            &.show {
              background-color: $concour;
              color: #fff;
              border: none;
              cursor: default;
              > span {
                opacity: 1 !important;
                padding-top: 19px;
                padding-bottom: 19px;
                .date {
                  margin: 0 -0.5em 0 0;
                }
              }
            }
            &.none {
              cursor: default;
              span {
                opacity: 1;
              }
              .date {
                display: inline;
              }
            }
            &:nth-of-type(1).show span {
              background-image: url(../assets/img/common/ico_pencil_on.png);
            }
            &:nth-of-type(2).show span:nth-of-type(1) {
              background-image: url(../assets/img/common/ico_cup_on.png);
            }
          }
        }
      }
      .tab-contents {
        display: none;
        &.show {
          display: block;
        }
        ul {
          li {
            border-bottom: 1px solid #d6d6d6;
            .desc {
              @include flex();
              padding: 25px 0;
              h3 {
                font-size: 18px;
                font-weight: bold;
                color: $concour;
                line-height: 1.6;
                width: 200px;
                -webkit-transform: perspective(1);
              }
              > div {
                width: 76%;
                div {
                  margin-bottom: 15px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
              .rounded-btn,
              .download-btn {
                margin: 0;
                width: 58.5%;
              }
            }
            .map {
              height: 334px;
              border: 1px solid #ddd;
              margin-bottom: 30px;
            }
          }
          li:last-child {
            border-bottom: none;
          }
        }
      }
      .rounded-btn,
      .download-btn {
        width: 44.5%;
        margin: 0 auto 30px;
        background: $concour;
        color: #fff;
      }
      .download-btn {
        span {
          padding-left: 30px;
          background-image: url(../assets/img/common/ico_download.png);
          background-repeat: no-repeat;
          background-size: 17px auto;
          background-position: center left;
        }
      }
      .rounded-btn {
        span {
          padding-left: 23px;
          &:before {
            content: " ";
            border: 7px dashed transparent;
            border-left: 11px solid #fff;
            top: calc(50% - 7px);
            left: 0;
          }
        }
      }
    }
  }
  .ttl-select {
    margin: 85px 0 60px;
    @include flex();
    h2 {
      font-size: 34px;
      color: $concour;
      font-weight: bold;
      text-shadow: $white-border;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      text-shadow: $white-border;
      margin: 18px 0 0;
      letter-spacing: 0.15em;
    }
    .select-area {
      width: 60.21%;
      > div:not(.search-btn) {
        width: 39%;
        label {
          color: $concour;
          margin-bottom: 12px;
        }
        span {
          background-color: $concour;
          letter-spacing: 0;
        }
      }
      input {
        background-color: $concour;
      }
    }
  }
  .card-area {
    @include flex();
    flex-wrap: wrap;
  }
  .to-list-btn {
    margin: 40px auto 0;
    width: 48.98%;
    a {
      color: $concour;
      border: 3px solid $concour;
    }
    span {
      padding-left: 24px;
    }
    span:before {
      content: " ";
      border: 8px dashed transparent;
      border-left: 12px solid $concour;
      left: 0;
    }
  }
  .bottom-nav ul {
    width: 300px;
  }
  @media only screen and (min-width: 751px) {
    .tab-btn {
      li {
        margin-bottom: -1px;
        span {
          transition: opacity 0.3s ease-out;
        }
        &:hover span {
          opacity: 0.7;
        }
      }
    }

    .tab-contents {
      .desc.pdf {
        h3 {
          line-height: 50px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 750px) {
    $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff,
      -1px 0 1px #fff, -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff,
      1px 1px 1px #fff;
    .inner {
      padding: 0;
      padding: 0;
      .to-list-link {
        margin: 0 -5.35vw;
        background: #fff;
        padding: 4vw 5.35vw;
        a {
          font-size: 0.8rem;
          background: none;
          display: inline-block;
        }
        a:before {
          border: 1.6vw dashed transparent;
          border-right: 2.2vw solid $concour;
          top: calc(50% - 1.6vw);
        }
      }
      article {
        margin: 0 -5.35vw;
        padding: 0;
        .event-img + div {
          padding: 0 5.35vw 10.7vw;
        }
        .tab-btn {
          margin: 0 -5.35vw 2.8vw;
          padding: 4.5vw 5.35vw 0;
          ul {
            li {
              max-height: 11.9vw;
              font-size: 1.28rem;
              border: 1px solid #00a8ff;
              border-bottom: none;
              span {
              }
              &.show {
                border: 1px solid #00a8ff;
                border-bottom: none;
              }
            }
            li:nth-of-type(1) {
              span {
                letter-spacing: 0.1em;
                padding: 3.87vw 0;
                padding-left: 5.5vw;
                background-size: 3.2vw auto;
              }
            }
            li:nth-of-type(2) {
              span:nth-of-type(1) {
                letter-spacing: 0.1em;
                background-size: 4.7vw auto;
                padding: 3.87vw 0;
                padding-left: 5.5vw !important;
              }
              .date {
                font-size: 0.9rem;
                display: none;
                padding: 1.2vw 0 0;
              }
              &.none {
                padding: 1.44vw 0;
                span:nth-of-type(1) {
                  padding: 0.5vw 0;
                }
                .date {
                  display: block;
                }
              }
            }
          }
        }
        .tab-contents {
          ul {
            li {
              .desc {
                display: block;
                padding: 5vw 0;
                h3 {
                  width: 100%;
                  font-size: 1.11rem;
                  margin-bottom: 0.5vw;
                }
                .rounded-btn,
                .download-btn {
                  margin-top: 1.8vw;
                }
                > div {
                  width: 100%;

                  div {
                    margin-bottom: 1.5vw;
                    &:last-child {
                      margin-bottom: 0;
                    }
                  }
                }
              }
              .map {
                height: 44vw;
                margin-bottom: 5vw;
              }
            }

            li:last-child {
              border-bottom: 1px solid #d6d6d6;
            }
          }
        }
        .rounded-btn,
        .download-btn {
          margin-bottom: 5vw;
        }
        .rounded-btn {
          span {
            padding-left: 4.8vw;
            &:before {
              border: 1.6vw dashed transparent;
              border-left: 2.4vw solid #fff;
            }
          }
        }
      }
      .to-list-btn {
        border: 1.5px solid $concour;
        margin: 8vw 0 1vw;
        span {
          padding-left: 4.8vw;
          &:before {
            border: 1.6vw dashed transparent;
            border-left: 2.4vw solid $concour;
          }
        }
      }
    }
    .ttl-select {
      display: block;
      margin: 9.4vw 0 9.4vw;
      .ttl {
        margin-bottom: 8vw;
        text-align: center;
      }
      h2 {
        padding-left: 12.5vw;
        display: inline-block;
        letter-spacing: 0.08em;
        background-image: url(../assets/img/common/ico_concour_sp.png);
        background-repeat: no-repeat;
        background-size: 11vw auto;
        background-position: center left;
        line-height: 1.4;

        font-size: 2.14rem;
      }
      p {
        margin-top: 3vw;
        font-size: 0.94rem;
        letter-spacing: 0.1em;
        text-shadow: $white-border2;
      }
      .select-area {
        flex-wrap: wrap;
        width: 100%;
        > div:not(.search-btn) {
          width: 48.5%;
        }
        label {
          color: $concour;
        }
        span {
          background: $concour;
        }
        input {
          width: 100%;
          background-color: $concour;
        }
      }
      .card-area {
        display: block;
        .card {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
$concour: #00a8ff;
.concour-detail .inner article .tab-contents ul li .desc {
  p {
    font-size: 15px;
    line-height: 1.8;
    a {
      color: $concour;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }

  @media only screen and (max-width: 750px) {
    p {
      width: 100%;
      font-size: 1.025rem;
      line-height: 1.4;
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>

<script>
import $ from "jquery";
import Base from "./_Base";
import card from "../components/card";
export default {
  mixins: [Base],
  data: function() {
    return {
      resultBtnDisabledClass: "none",
      showClass: "show"
    };
  },
  components: {
    card
  },
  computed: {
    ConcourDetail() {
      return this.$store.state.data.ConcourDetail || {};
    }
  },
  methods: {
    resultBtnDisabled: function(data) {
      if (!data) {
        return this.resultBtnDisabledClass;
      }
    },
    resultShow: function(tabName, data) {
      if (data && tabName == "result") {
        return this.showClass;
      } else if (!data && tabName == "info") {
        return this.showClass;
      } else if (data && tabName == "btn-result") {
        return this.showClass;
      } else if (!data && tabName == "btn-result") {
        return this.resultBtnDisabledClass;
      }
    }
  },
  mounted: function() {
    // function addClassPDF() {
    //    $(".download-btn, .rounded-btn").each(function() {
    //       $(this)
    //         .parents(".desc")
    //         .addClass("pdf");
    //     });
    // }
    $(document).on("click", ".tab-btn .btn:not(.none)", function() {
      if (!$(this).hasClass("show")) {
        $(".show").removeClass("show");
        $(this).addClass("show");
        $("article .tab-contents").hide();
        var $e = $("article .tab-contents").eq($(this).index());
        $e.fadeIn(400);
        // addClassPDF();
      }
    });
    // $(window).on("load", function() {
    //   setTimeout(function(){
    //     addClassPDF();
    //   },1000)
    // });
  },
  watch: {
    ConcourDetail (newData, oldData) {
      if (newData.post && newData.post.title && !oldData.post) {
        window.document.title = newData.post.title + ' | まなびアサヒ.com'
      }
    }
  }
};
</script>
